import CustomerAgentUsageDto from "../../../dtos/customeragentmodule/CustomerAgentUsageDto";

class DeleteCustomerAgentResult {
    Deleted: boolean;
    UsageDetails: CustomerAgentUsageDto[];

    constructor(deleted: boolean, usageDetails: CustomerAgentUsageDto[]) {
        this.Deleted = deleted;
        this.UsageDetails = usageDetails;
    }
}

export default DeleteCustomerAgentResult;
